import React from "react";

const Coffee = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 5.12109C5.59 5.12109 5.25 4.78109 5.25 4.37109V2.62109C5.25 2.21109 5.59 1.87109 6 1.87109C6.41 1.87109 6.75 2.21109 6.75 2.62109V4.37109C6.75 4.79109 6.41 5.12109 6 5.12109Z"
        fill={color}
      />
      <path
        d="M10 5.12109C9.59 5.12109 9.25 4.78109 9.25 4.37109V2.62109C9.25 2.21109 9.59 1.87109 10 1.87109C10.41 1.87109 10.75 2.21109 10.75 2.62109V4.37109C10.75 4.79109 10.41 5.12109 10 5.12109Z"
        fill={color}
      />
      <path
        d="M14 5.12109C13.59 5.12109 13.25 4.78109 13.25 4.37109V2.62109C13.25 2.21109 13.59 1.87109 14 1.87109C14.41 1.87109 14.75 2.21109 14.75 2.62109V4.37109C14.75 4.79109 14.41 5.12109 14 5.12109Z"
        fill={color}
      />
      <path
        d="M22.25 13.2517C22.25 10.6317 20.22 8.51172 17.66 8.29172C16.92 7.08172 15.6 6.26172 14.08 6.26172H6.71C4.39 6.26172 2.5 8.15172 2.5 10.4717V11.0017H18.29V10.4717C18.29 10.2817 18.26 10.0917 18.23 9.91172C19.68 10.3417 20.75 11.6617 20.75 13.2517C20.75 14.8217 19.71 16.1317 18.29 16.5717V12.0017H2.5V17.7917C2.5 20.1117 4.39 22.0017 6.71 22.0017H14.08C16.28 22.0017 18.07 20.3017 18.25 18.1417C20.53 17.6817 22.25 15.6617 22.25 13.2517Z"
        fill={color}
      />
    </svg>
  );
};

export default Coffee;
